module.exports = __webpack_public_path__ + "static/media/StandEmpty-2.88b289cc.png";